import { KEYCLOAK_HOST } from './environment'

import Keycloak from 'keycloak-js'
import { MockKeycloak } from '../../tests/helpers/authHelpers'

export const keycloak = window?.Cypress
  ? new MockKeycloak()
  : // @ts-ignore
    new Keycloak({
      url: KEYCLOAK_HOST,
      realm: 'TomraConnectUsers',
      clientId: 'mytomra-hotline-tool-ui'
    })

export const loggedInUserHasRole = (role: string) => {
  if (keycloak.tokenParsed) {
    const { full_resource_access } = keycloak.tokenParsed as { full_resource_access: string[] }
    return full_resource_access.includes(role)
  }

  return false
}
